import type { Image } from '@sanity/types';

export interface ImageDimensions {
  width: number;
  height: number;
  aspectRatio: number;
}

export function getImageDimensions(image: Image): ImageDimensions | null {
  if (!image?.asset?._ref) {
    return null;
  }

  const dimensions = image.asset._ref.split('-')[2];
  const [width, height] = dimensions.split('x').map(Number);

  if (!width || !height || Number.isNaN(width) || Number.isNaN(height)) {
    return null;
  }

  return {
    width,
    height,
    aspectRatio: width / height,
  };
}
